import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import ToDateNotificator from 'components/ToDateNotificator';
import { formatOrder } from 'components/CodeInfo';
import CodeInfoSection from 'components/CodeInfoSection';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoAdditionalDues extends Component {

    render() {
        const { additionalDues } = this.props;
        const summary = getTitleSummary(additionalDues)
        return (
            <CodeInfoSection
                title={{
                    headers: ['Антидемпинговая пошлина'],
                    rows: summary
                }}
                expanded={(additionalDues.length !== 0) ? true : false}
                table={{
                    headers: [
                        '',
                        'Страна происхождения',
                        'Описание',
                        'Ставка',
                        'Нормативный документ'
                    ],
                    rows: additionalDues.map(({ to_date = null, country = '', description = '', hint = '', order, order_date, orders_info = null }) => ([
                        <ToDateNotificator to_date={to_date} />,
                        country,
                        description,
                        hint,
                        formatOrder(order, order_date, orders_info)
                    ]))
                }}
            />
        );
    }
}

// function getTitleSummary(items) {
//     var rate = items.length !== 0 ? items[0].hint + (items.length > 1 ? ' (базовая ставка)' : ''): null;
//     items.forEach(element => {
//         if (element.description === 'Базовая ставка') {
//             rate = element.hint + (items.length > 1 ? ' (базовая ставка)' : '');
//             return;
//         }
//     });
//     return [[rate]];
// }
function getTitleSummary(items) {
    return items.length > 0 ? items.slice(0, 1).map(({ hint = '', order, order_date, orders_info, }) =>
        ([`${hint}` + (items.length > 1 ? ' (базовая ставка)' : ''), formatOrder(order, order_date, orders_info)])) : null
}





// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoAdditionalDues.js